// Import the functions you need from the SDKs you need
import { FirebaseApp } from "firebase/app";
import { Auth, User } from "firebase/auth";

import { Firestore, collection, deleteDoc, doc, getDoc, getDocs, getFirestore, setDoc } from "firebase/firestore";
import { FirebaseAuth } from "./firebaseauth";
import { MLLog } from "../../base/lib/logger/Logger";

//https://firebase.google.com/docs/firestore/quickstart
export class FirebaseFirestore {

  private _fs!: Firestore;
  private _fauth!: FirebaseAuth;

  public constructor(app: FirebaseApp, fauth: FirebaseAuth) {
    //this._auth = getFirestore(app);
    this._fs = getFirestore(app);
    this._fauth = fauth;
  }

  async addData(documentPath: string, data: any): Promise<void> {
    const user: User | null = await this._fauth.current;

    if (user) {
      const userDocRef = doc(this._fs, "users", user.uid, documentPath);
      try {

        await setDoc(userDocRef, data);
        MLLog.logDev("Data as been saved", data)
        MLLog.logDev("Doc was ", userDocRef)
      } catch (error: any) {
        MLLog.logDev("Error in save data", data)
        MLLog.logDev("Error in save data", error)
      }
      return;
    } else {
      // Handle the case where no user is logged in
      console.error('User not logged in');
      return Promise.reject("Cannot create Doc");
    }
  }


  async setSystemData(documentPath: string, data: any): Promise<void> {
    let path = "system/" + documentPath;
    const userDocRef = doc(this._fs, path);
    await setDoc(userDocRef, data);
    return;

  }

  async getSystemData(documentPath: string): Promise<any | null> {
    //MLLog.logDev("Hello")
    let path = "system/" + documentPath;
    //MLLog.logDev("path" + path)
    const userDocRef = doc(getFirestore(), path);
    const docSnap = await getDoc(userDocRef);
    if (docSnap.exists()) {
      return docSnap.data();
    }
    return null;
  }

  async getUserModelData(documentPath: string): Promise<any | null> {
    return this.getSystemData("users/" + documentPath);
  }

  async getData(documentPath: string): Promise<any | null> {
    const db = getFirestore();
    const user: User | null = await this._fauth.current;
    //MLLog.logDev("user", user)
    if (user) {
      const userDocRef = doc(this._fs, "users", user.uid, documentPath);
      const docSnap = await getDoc(userDocRef);

      //MLLog.logDev("docSnap", docSnap)
      //MLLog.logDev("docSnap", docSnap.exists())
      if (docSnap.exists()) {
        return docSnap.data();
      } else {
        return null;
      }
    } else {
      return null;
    }
  }

  async dataExists(documentPath: string): Promise<boolean> {
    const db = getFirestore();
    const user: User | null = await this._fauth.current;

    if (user) {
      const userDocRef = doc(this._fs, "users", user.uid, documentPath);
      const docSnap = await getDoc(userDocRef);
      return docSnap.exists();
    } else {
      return false;
    }
  }

  // In firebasefs.ts aggiungi questo metodo nella classe FirebaseFirestore
  async deleteData(documentPath: string): Promise<void> {
    const user: User | null = await this._fauth.current;
    if (user) {
      // Ricordati di importare 'deleteDoc' da "firebase/firestore" in cima al file
      const userDocRef = doc(this._fs, "users", user.uid, documentPath);
      try {
        await deleteDoc(userDocRef);
        MLLog.logDev("Documento eliminato fisicamente da Firebase:", documentPath);
      } catch (error) {
        MLLog.logDev("Errore durante la delete fisica:", error);
      }
    }
  }


  // Dentro la classe FirebaseFirestore:
  async listDocumentIds(collectionPath: string): Promise<string[]> {
    const user: User | null = await this._fauth.current;
    if (!user) {
      return [];
    }

    try {
      // Puntiamo alla sotto-collezione sotto l'utente corrente
      const subCollectionRef = collection(this._fs, "users", user.uid, collectionPath);
      const querySnapshot = await getDocs(subCollectionRef);

      // Mappiamo lo snapshot per estrarre solo l'ID del documento (l'uid dell'asset)
      const ids: string[] = [];
      querySnapshot.forEach((doc) => {
        ids.push(doc.id);
      });

      return ids;
    } catch (error) {
      MLLog.logDev("Error listing document IDs", error);
      return [];
    }
  }

  public test0001() {
    this.getUserModelData("shop/items2026").then(
      (data) => {
        MLLog.logDev("Receiving Shop")
        MLLog.logDev(data)
      }
    );
    this.getUserModelData("achievements/main_achievements").then(
      (data) => {
        MLLog.logDev("Receiving Achievements")
        MLLog.logDev(data)
        data.data[0].name = "hello world"
        this.setSystemData("users/achievements/main_achievements", data).then(
          () => {
            MLLog.logDev("Change Done")
          }
        ).catch(err => {
          MLLog.logDev("Request couldn't be accomplished")
          MLLog.logDev(err)
        });
      }
    );
  }

}